<template>
    <div id="reg-form" class="cta">
        <div class="cta__cnt">
            <img src="https://storage.yandexcloud.net/boxberrysite-public/tilda/reg-img.png" alt="reg lady" class="reg-img">
            <ValidationObserver ref="formRequest">
                <form :action="sendUrl"
                      id="reg-form-form"
                      class="reg-form mb-minus"
                      @submit.prevent="send">
                    <div class="legend">{{title}}</div>
                    <ValidationProvider mode="passive" name="organization" slim rules="required" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="text"
                                   id="reg-form_legal"
                                   placeholder="Юридическое лицо"
                                   v-model="formData.organization">
                            <label for="reg-form_legal">Юридическое лицо</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider mode="passive" name="name" slim rules="required" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="text"
                                   id="reg-form_fio"
                                   placeholder="ФИО"
                                   v-model="formData.name">
                            <label for="reg-form_fio">ФИО</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider mode="passive" name="phone" slim :rules="{required: true, phone: vueTheMaskConfig4Phone.mask}" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="tel"
                                   id="reg-form_phone"
                                   placeholder="Ваш номер телефона"
                                   v-mask="vueTheMaskConfig4Phone"
                                   v-model="formData.phone">
                            <label for="reg-form_phone">Ваш номер телефона</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider mode="passive" name="email" slim rules="required|email" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="email"
                                   id="reg-form_email"
                                   placeholder="Ваш e-mail адрес"
                                   v-model="formData.email">
                            <label for="reg-form_email">Ваш e-mail адрес</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider mode="passive" name="site" slim v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="text"
                                   id="reg-form_site"
                                   placeholder="Ваш сайт"
                                   v-model="formData.site"
                                   @blur="showMsgAddressSite = false"
                                   @focus="() => onFocusAddressSite(errors[0])"
                            >
                            <label for="reg-form_site">Ваш сайт</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                  <span
                    v-show="showMsgAddressSite"
                    class="info-mess"
                  >
                    Пожалуйста, укажите ваш сайт в&nbsp;формате &laquo;boxberry.ru&raquo;. Если у&nbsp;вас еще нет сайта,
                    оставьте поле пустым. Если сайтов несколько, укажите основной
                  </span>
                    <ValidationProvider mode="passive" name="social_media" slim v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <input type="text"
                                   id="reg-form_social_media"
                                   placeholder="Ссылка на соц.сети"
                                   v-model="formData.social_media"
                                   @blur="showMsgSocialMedia = false"
                                   @focus="() => onFocusSocialMedia(errors[0])"
                            >
                            <label for="reg-form_social_media">Ссылка на соц.сети</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                  <span
                    v-show="showMsgSocialMedia"
                    class="info-mess"
                  >
                    Здесь вы&nbsp;можете указать ник или ссылку на&nbsp;инстаграм, вконтакте, авито,
                    озон и&nbsp;др. &mdash;&nbsp;любую ссылку на&nbsp;ваш магазин,
                    которая не&nbsp;является сайтом вашей компании.
                  </span>
                    <ValidationProvider mode="passive" name="cityCode" slim via="cityName"  rules="required" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <Select2 v-model="formData.cityCode"
                                     :options="suggestionCities"
                                     ref="select2"
                                     :settings="select2Settings"
                                     id="cta_city_select"/>
                            <label for="cta_city_select" :class="[formData.cityCode !== '' ?  'small' : '']" >Город</label>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider mode="passive" name="captcha" slim rules="required" v-slot="{classes, errors}">
                        <div class="input-wrp" :class="classes">
                            <div class="captcha-wrp" @resize="captchaScale()">
                                <vue-recaptcha :sitekey="capthcaKey" v-model="formData.captcha"
                                               ref="recaptcha"
                                               @verify="onVerify"
                                               @expired="onExpired"
                                               @render="captchaScale"
                                               :loadRecaptchaScript="true"></vue-recaptcha>
                            </div>
                            <span class="err-mess">{{errors[0]}}</span>
                        </div>
                    </ValidationProvider>
                    <button type="submit" class="button button-red" :disabled="!btnSendEnabled">{{btnSendText}}</button>
                    <div class="check-wrp">
                        <input type="checkbox"
                               id="reg-form_spam"
                               name="spam"
                               v-model="formData.subscription"
                        >
                        <label for="reg-form_spam" class="checkbox">
                            <span class="checkbox__mark"></span>
                            <span class="checkbox__text">Подписаться на рассылку новостей Boxberry</span>
                        </label>
                    </div>
                    <div class="check-wrp">
                        <input type="checkbox"
                               id="reg-form_agreement"
                               name="spam"
                               v-model="formData.agreement"
                               required
                        >
                        <label for="reg-form_agreement" class="checkbox">
                            <span class="checkbox__mark"></span>
                            <span class="checkbox__text">
                              Я даю согласие на&nbsp;обработку своих
                              <a
                                href="https://boxberry.ru/e-commerce/dokumenty/soglasenie-o-konfidencial-nosti-informacii-boksberri-soft"
                                target="_blank"
                                rel="noopener"
                                style="color: #ed1651 !important;"
                              >
                                персональных данных
                              </a>
                            </span>
                        </label>
                    </div>
                </form>
            </ValidationObserver>
        </div>

        <div class="modal-window-error" style="display: none" v-show="isShowModal">
            <div class="modal-overlay">
                <div class="modal-window">
                    <a href="javascript:void(0)" class="close" @click="closeModal">
                        <svg class="close-window">
                            <g>
                                <path d="M1 1L10 10M19 19L10 10M10 10L19 1L1 19" stroke="#333333"/>
                            </g>
                        </svg>
                    </a>
                    <h2 class="headline" v-html="errorModalMessage"></h2>
                    <a href="javascript:void(0)" class="register-another-email" @click="closeModal(true)">
                        Попробовать снова
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueRecaptcha from "vue-recaptcha";
    import {mask} from "vue-the-mask";
    import axios from "axios";
    import Select2 from "v-select2-component";
    import {ValidationProvider, ValidationObserver, configure, extend} from 'vee-validate';
    import {required, email} from 'vee-validate/dist/rules';

    extend('required', {
        ...required,
        message: 'Поле обязательно для заполнения'
    });
    extend('email', {
        ...email,
        message: 'Неверный формат email адреса'
    });
    extend('phone', {
        params: ['phoneMask'],
        validate: (value, {phoneMask}) => {
            let regexPhone = new RegExp("^\\+\\d+\\s*\\(\\d+\\)\\s*[-\\d]*\\d+$");
            return phoneMask.length === value.length && regexPhone.test(value);
        },
        message: 'Неверный формат номера телефона'
    });

    configure({
        classes: {
            valid: 'valid',
            invalid: 'invalid',
        }
    });

    export default {
        name: "RequesForm",
        components: {
            VueRecaptcha,
            Select2,
            ValidationObserver,
            ValidationProvider,
        },
        directives: {
            mask,
        },
        props: [
            "title",
            "capthcaKey",
            "sendUrl",
            "citieListApiUrl",
            "lsNameItem"
        ],
        data() {
            return {
                formData: {
                    organization: '',
                    phone: '',
                    name: '',
                    email: '',
                    site: '',
                    social_media: '',
                    cityCode: '',
                    cityName: '',
                    subscription: true,
                    agreement: true,
                    captcha: ''
                },
                verifyRecapcha: false,
                cityList: [],
                suggestionCities: [],
                select2Settings: {
                    "dropdownCssClass": "select2-dropdown--custom",
                    "selectionCssClass": "select2-dropdown--custom",
                    "width": "100%",
                    "theme": "custom",
                    templateSelection: this.changeCityName,
                    language: {
                        noResults: function () {
                            return 'Город не найден';
                        }
                    },
                },
                vueTheMaskConfig4Phone: {
                    mask: '+7 (___) ___-__-__',
                    tokens: {
                        '_': {pattern: /\d/}
                    }
                },
                isShowModal: false,
                errorModalMessage: '',
                btnSendText: 'Зарегистрироваться',
                btnSendEnabled: true,
              showMsgAddressSite: false,
              showMsgSocialMedia: false,
            };
        },
        mounted() {
            window.addEventListener("resize", () => {
                this.captchaScale();
            })
            if (this.$props.citieListApiUrl !== undefined) {
                this.getCities();
            }

            setTimeout(() => {
              const { select2 } = this.$refs.select2;
              const self = this;
              select2.on('select2:opening', function (e) {
                if (self.showMsgSocialMedia || self.showMsgAddressSite) {
                  e.preventDefault();
                  setTimeout(() => {
                    select2.select2('open');
                  }, 0);
                }
              });
            }, 100);
        },
        methods: {
            //Получение городов
            getCities: function () {
                let citiesList = sessionStorage.getItem(this.$props.lsNameItem);
                if (citiesList && citiesList.length > 0) {
                    this.suggestionCities = JSON.parse(citiesList);
                } else {
                    axios.get(
                        this.$props.citieListApiUrl,
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        },
                    ).then((response) => {
                        if (response.status === 200) {
                            this.cityList = [];
                          const { cities } = response.data;
                          const { country } = response.data;
                          const responseData = { cities, country };
                          responseData.country.map((item) => {
                                item.cities = responseData.cities.filter((citie) => {
                                    return citie.country_code == item.code;
                                });
                                this.cityList.push(item);
                            });
                            this.prepareSuggestionCitys();
                        }
                    }).catch((error) => {
                        console.error(error);
                    });
                }
            },
            //Подготовка городов для Select2
            prepareSuggestionCitys: function () {
                this.cityList.map((country) => {
                    let children = [];
                    country.cities.map((city) => {
                        children.push({
                            id: city.code,
                            text: city.name,
                        });
                    });
                    this.suggestionCities.push({
                        "text": country.name,
                        "children": children,
                        "mask_phone": country.mask_phone
                    });
                });
                if (this.suggestionCities.length > 0) {
                    sessionStorage.setItem(this.$props.lsNameItem, JSON.stringify(this.suggestionCities));
                }
            },
            //Изменение назване города (подстановка страны)
            changeCityName: function (event) {
                if (event.id !== "" && event.id !== undefined) {
                    this.formData.cityName = event.text;
                    let countryName;
                    this.suggestionCities.map(
                        (country) => {
                            country.children.map(
                                (city) => {
                                    if (event.id == city.id) {
                                        countryName = `${country.text}, ${event.text}`;
                                        if (country.mask_phone) {
                                            this.vueTheMaskConfig4Phone.mask = country.mask_phone;
                                        }
                                    }
                                },
                            );
                        },
                    );
                    return countryName;
                }
            },
            //Отправка данных на рагистрацию
            send: function () {
                this.errorModalMessage = '';
                this.$refs.formRequest.validate().then(success => {
                    if (!success) {
                        return;
                    }
                    if (!this.verifyRecapcha) {
                        return;
                    }
                    let timerSend = this.animateSendStart();

                    let prepareDataForSend = new FormData();
                    prepareDataForSend.append("organization", this.formData.organization);
                    prepareDataForSend.append("phone", this.formData.phone);
                    prepareDataForSend.append("name", this.formData.name);
                    prepareDataForSend.append("email", this.formData.email);
                    prepareDataForSend.append("site", this.formData.site);
                    prepareDataForSend.append("socialMedia", this.formData.social_media);
                    prepareDataForSend.append("cityCode", this.formData.cityCode);
                    prepareDataForSend.append("cityName", this.formData.cityName);
                    prepareDataForSend.append("subscription", this.formData.subscription);
                    prepareDataForSend.append("agreement", this.formData.agreement);
                    prepareDataForSend.append("captcha", this.formData.captcha);
                    prepareDataForSend.append("referer", document.location.href);
                    axios.post(
                        this.$props.sendUrl,
                        prepareDataForSend,
                    ).then((response) => {
                        if (response.status === 200) {
                            if (!response.data.error && typeof response.data.url !== 'undefined') {
                              document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'mim_send_form' } }));
                              // eslint-disable-next-line
                                if (typeof ym === 'function') {
                                    console.log('Яндекс Метрика — mim_send_form');
                                    // eslint-disable-next-line
                                    ym(68977201,'reachGoal','mim_send_form');
                                }
                                // eslint-disable-next-line
                                if (typeof gtag === 'function') {
                                    console.log('Google Аналитика — send_form');
                                    // eslint-disable-next-line
                                    gtag('event','send_form');
                                }
                                setTimeout(() => {
                                  document.location.href = response.data.url;
                                }, 100);
                            } else if (response.data.messages !== 'undefined' && response.data.messages.length > 0) {
                                this.showModal(response.data.messages);
                            }
                        }
                    }).catch((error) => {
                        if (error.response && error.response.data.error) {
                            for (let key in error.response.data) {
                                if (key === 'captcha') {
                                    this.resetRecaptcha();
                                }
                            }
                            this.$refs.formRequest.setErrors(error.response.data);
                            if (error.response.data.link_group) {
                              this.$refs.formRequest.setErrors({
                                site: 'Укажите хотя бы одну ссылку на ваш магазин',
                                social_media: 'Укажите хотя бы одну ссылку на ваш магазин',
                              });
                            }
                        }
                    }).finally(() => {
                        this.animateSendEnd(timerSend);
                    });
                });
            },
            //Верификация рекапчи
            onVerify: function (response) {
                this.formData.captcha = response;
                this.verifyRecapcha = true;
            },
            //Вышло время активности рекапчи
            onExpired: function () {
                this.formData.captcha = '';
                this.verifyRecapcha = false;
            },
            //Сброс рекапчи
            resetRecaptcha() {
                this.formData.captcha = '';
                this.verifyRecapcha = false;
                this.$refs.recaptcha.reset();
            },
            // scaling captcha
            captchaScale: function () {
                let captchaWrp = this.$el.querySelector(".captcha-wrp");
                let captcha = captchaWrp.querySelector("[style]");
                captcha.setAttribute("style", `width: 304px; height: 78px; transform-origin: top left; transform: scale(${captchaWrp.offsetWidth / (captcha.offsetWidth - 2)})`);
            },
            showModal: function (messages = ['Попробуйте ещё раз']) {
                for (let i = 0; i < messages.length; i++) {
                    this.errorModalMessage += messages[i] + '<br>';
                }
                this.isShowModal = true;
            },
            closeModal: function (tryAgain = false) {
                if (tryAgain) {
                    this.formData.email = '';
                }
                this.isShowModal = false;
            },
            animateSendStart: function (text = 'Подождите') {
                this.btnSendEnabled = false;
                this.btnSendText = text;
                return setInterval(() => {
                let countDots = this.btnSendText.match(/\./g);
                if (countDots !== null && countDots.length > 2) {
                    this.btnSendText = text;
                }
                this.btnSendText += '.';
              }, 300);
            },
            animateSendEnd: function (timerId, text = 'Зарегистрироваться') {
                clearInterval(timerId);
                this.btnSendText = text;
                this.btnSendEnabled = true;
            },
          onFocusSocialMedia(error) {
              if (!error) {
                this.showMsgSocialMedia = true;
              }
          },
          onFocusAddressSite(error) {
            if (!error) {
              this.showMsgAddressSite = true;
            }
          },
        },
    };
</script>

<style >
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap');

    #reg-form.cta *[hidden] {
        display: none !important;
    }

    #reg-form.cta *.invalid input,
    #reg-form.cta *.invalid .select2-container--custom {
        border-color: #ED1651 !important;
        box-shadow: none !important;
        outline: none;
    }
    #reg-form.cta input, #reg-form.cta input:focus, #reg-form.cta input:active,
    #reg-form.cta button, #reg-form.cta button:focus, #reg-form.cta button:active {outline: none;}

    /* inputs */
    #reg-form.cta input,
    #reg-form.cta button {
        font-family: inherit;
        }
    #reg-form.cta input, #reg-form.cta input:focus, #reg-form.cta input:active,
    #reg-form.cta button, #reg-form.cta button:focus, #reg-form.cta button:active {outline: none;}

    #reg-form.cta input {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: textfield;
        }

    #reg-form.cta input::-webkit-outer-spin-button,
    #reg-form.cta input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }

    #reg-form.cta input::-webkit-calendar-picker-indicator {
        display: none;
        }

    #reg-form.cta .input-wrp {
        position: relative;
        z-index: 0;
        }
    #reg-form.cta .input-wrp .err-mess {
        display: block;
        padding-left: 13px;
        margin-top: 4px;
        color: #ED1651;
        font-size: 12px;
        line-height: 160%;
        text-align: left;
        }
    #reg-form.cta .info-mess {
      display: block;
      padding-left: 13px;
      margin-top: -8px;
      margin-bottom: 10px;
      color: #3F3F3F;
      font-size: 12px;
      line-height: 160%;
      text-align: left;
    }
    #reg-form.cta .input-wrp:not(.invalid) .err-mess {display: none !important;}
    #reg-form.cta .input-wrp input {
        width: 100%;
        padding: 18px 12px 6px;
        background: transparent;
        color: #333333;
        font-size: 15px;
        line-height: 1.6;
        border: 1px solid #BBBBBB;
        border-radius: 4px;
        box-sizing: border-box;
        }

    #reg-form.cta .input-wrp input::placeholder {
        color: rgba(255, 255, 255, 0);
        }

    #reg-form.cta .input-wrp > label {
        position: absolute;
        left: 12px;
        right: 5px;
        top: 12px;
        color: rgba(51, 51, 51, 0.5);
        font-size: 15px;
        line-height: 1.6;
        text-align: left;
        z-index: -1;
        transition: all .3s linear;
        }

    #reg-form.cta .input-wrp input:focus ~ label,
    #reg-form.cta .input-wrp input:not(:placeholder-shown) ~ label,
    #reg-form.cta .input-wrp label.small {
        top: 5px;
        transform: translateY(0);
        font-size: 12px;
        }

    #reg-form.cta .input-wrp .pass-view {
        position: absolute;
        top: 13px;
        right: 18px;
        display: block;
        width: 24px;
        height: 24px;
        background: center center / contain no-repeat transparent;
        border: none;
        font-size: 0;
        color: transparent;
        cursor: pointer;
    }

    #reg-form.cta .input-wrp input[type="password"] ~ .pass-view {
        background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjkxMTEgNy43NjkzMkMyMy43MjIxIDcuNDkxMzMgMTkuMTgwMSAwLjk4MDQ2OSAxMiAwLjk4MDQ2OUM1LjgzODg0IDAuOTgwNDY5IDAuMzQ4NzQ0IDcuNDUzOTQgMC4xMTc3NCA3LjcyOTlDLTAuMDM5MjQ2OCA3LjkxNzkyIC0wLjAzOTI0NjggOC4xOTM4OCAwLjExNzc0IDguMzgyODlDMC4zNDg3NDQgOC42NTg4NSA1LjgzODg0IDE1LjEzMjMgMTIgMTUuMTMyM0MxOC4xNjExIDE1LjEzMjMgMjMuNjUxMSA4LjY1ODg1IDIzLjg4MjEgOC4zODI4OUMyNC4wMjcyIDguMjA5MDQgMjQuMDQwMSA3Ljk1NzM0IDIzLjkxMTEgNy43NjkzMlpNMTIgMTQuMTIxNUM3LjA2MDg5IDE0LjEyMTUgMi4zNjQ3OCA5LjM2MDQxIDEuMTcxNzkgOC4wNTY0MkMyLjM2MjgxIDYuNzUxNDMgNy4wNTM5IDEuOTkxMzUgMTIgMS45OTEzNUMxNy43NzkgMS45OTEzNSAyMS44NTgxIDYuNzQ1MzcgMjIuODU0MSA4LjAyOTEzQzIxLjcwNDEgOS4yOTE2NiAxNi45ODEgMTQuMTIxNSAxMiAxNC4xMjE1WiIgZmlsbD0iIzg4ODg4OCIvPgo8cGF0aCBkPSJNMTIgNC4wMTMwMUM5Ljc5MzkzIDQuMDEzMDEgNy45OTk5IDUuODI2NDYgNy45OTk5IDguMDU2MzdDNy45OTk5IDEwLjI4NjMgOS43OTM5MyAxMi4wOTk3IDEyIDEyLjA5OTdDMTQuMjA2IDEyLjA5OTcgMTYgMTAuMjg2MyAxNiA4LjA1NjM3QzE2IDUuODI2NDYgMTQuMjA2IDQuMDEzMDEgMTIgNC4wMTMwMVpNMTIgMTEuMDg5QzEwLjM0NTkgMTEuMDg5IDguOTk5OTEgOS43MjgzNCA4Ljk5OTkxIDguMDU2NDJDOC45OTk5MSA2LjM4NDUgMTAuMzQ1OSA1LjAyMzg4IDEyIDUuMDIzODhDMTMuNjU0IDUuMDIzODggMTUgNi4zODQ1IDE1IDguMDU2NDJDMTUgOS43MjgzNCAxMy42NTQgMTEuMDg5IDEyIDExLjA4OVoiIGZpbGw9IiM4ODg4ODgiLz4KPC9zdmc+Cg==")
    }

    #reg-form.cta .input-wrp input[type="text"] ~ .pass-view {
        background-image: url("data:image/svg+xml;base64,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")
    }

    #reg-form.cta .captcha-wrp {
        position: relative;
        max-width: 304px;
        margin-left: auto;
        margin-right: auto;
        border: 1px solid #BBBBBB;
        border-radius: 4px;
        overflow: hidden;
    }
    #reg-form.cta .input-wrp.invalid .captcha-wrp {border-color: #ED1651;}
    #reg-form.cta .captcha-wrp::before {
        content: '';
        display: block;
        width: 100%;
        padding-bottom: 25%;
        background: transparent;
    }

    #reg-form.cta .captcha-wrp > * {
        position: absolute;
        top: -1px;
        right: -1px;
        bottom: -1px;
        left: -1px;
        z-index: 1;
        }

    #reg-form.cta .captcha-wrp * > * {
        transform-origin: left top;
    }

    /* end inputs */
    /* checkboxes */
    #reg-form.cta .check-wrp {
        padding-left: 13px;
        color: #3F3F3F;
    }

    #reg-form.cta .check-wrp input {
        display: none;
    }

    #reg-form.cta .check-wrp .checkbox {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    #reg-form.cta .check-wrp .checkbox__mark {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 12px;
        border: 1px solid #c1c1c1;
        border-radius: 3px;
        box-shadow: inset 3px 3px 0 #E7EAEF;
        flex: 0 0 22px;
        cursor: pointer;
    }

    #reg-form.cta .check-wrp .checkbox__mark::after {
        content: "";
        position: absolute;
        top: -1px;
        left: 5px;
        display: block;
        width: 19px;
        height: 15px;
        background: center center / contain no-repeat transparent url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMDQ1NzQgMTAuNjQ3MUw2LjExNDk0IDE0LjU3NjZMMTguODg2MSAxLjM1MTc1IiBzdHJva2U9IiNFRDE2NTEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
        transition: opacity .3s linear;
    }

    #reg-form.cta .check-wrp .checkbox__text {
        font-size: 12px;
        line-height: 1.33;
        text-align: left;
    }

    #reg-form.cta .check-wrp input:not(:checked) ~ .checkbox .checkbox__mark::after {
        opacity: 0;
    }

    @media (max-width: 1023px) {
        #reg-form.cta .check-wrp {
            padding-left: 0;
            }
        #reg-form .check-wrp {
            max-width: 190px;
            margin-left: auto;
            margin-right: auto;
            }
        }
    /* end checkboxes */
    /* buttons */
    #reg-form.cta .button {
        position: relative;
        z-index: 1;
        display: inline-block;
        margin: 3px;
        border: none;
        border-radius: 4px;
        box-sizing: border-box;
        line-height: 1.2;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
    }

    #reg-form.cta .button-red {
        color: #fff;
        font-weight: bold;
        background-color: #ED1651;
        box-shadow: 2px 2px 0 #D90F42;
    }

    #reg-form.cta .button-red:hover {
        background-color: #ED1651;
        box-shadow: 1px 1px 0 #D90F42;
    }

    #reg-form.cta .button-red:active {
        background-color: #FB2660;
        box-shadow: 1px 1px 0 #D90F42;
    }

    @media (max-width: 1023px) {
        #reg-form.cta .button {
            padding: 15px 30px 16px;
            font-size: 16px;
        }
    }

    @media (min-width: 1024px) {
        #reg-form.cta .button {
            padding: 13px 43px 15px;
            font-size: 18px;
        }
    }
    /* end buttons */

    /*select*/
    #reg-form.cta .select2-container--custom {
        position: relative;
        z-index: 1;
        font-family: "Open Sans", sans-serif;
        font-size: 15px;
        line-height: 1.6;
        text-align: left;
        border: 1px solid;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        }

    #reg-form.cta .select2-container--custom.select2-container--open {
        border-color: #747474;
        }

    #reg-form.cta .select2-container--custom:not(.select2-container--open) {
        border-color: #bbb;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        }

    #reg-form.cta .select2-container--custom .select2-selection--single {
        height: auto;
        padding-right: 25px;
        box-sizing: border-box;
        }

    #reg-form.cta .select2-container--custom .select2-selection--single .select2-selection__rendered {
        padding: 18px 12px 6px;
        font-weight: 400;
        }

    #reg-form.cta .select2-container--custom .select2-selection--single .select2-selection__rendered::after {
        content: "!";
        color: transparent;
        opacity: 0;
        }

    #reg-form.cta .select2-container--custom .select2-selection--single .select2-selection__placeholder {
        position: absolute;
        top: 50%;
        left: 13px;
        right: 35px;
        transform: translateY(-50%);
        color: rgba(51, 51, 51, 0.5);
        }

    #reg-form.cta .select2-container--custom .select2-selection__arrow {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 10px;
        display: flex;
        width: 20px;
        align-items: center;
        justify-content: center;
        }

    #reg-form.cta .select2-container--custom .select2-selection__arrow b {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin: 0;
        border: none;
        border-right: 2px solid #D90F42;
        border-bottom: 2px solid #D90F42;
        transition: all .3s linear;
        }

    #reg-form.cta .select2-container--custom:not(.select2-container--open) .select2-selection__arrow b {
        transform: rotate(45deg);
        }

    #reg-form.cta .select2-container--custom.select2-container--open .select2-selection__arrow b {
        transform: rotate(225deg);
        }

    .select2-dropdown--custom {
        margin-left: -1px;
        border-color: #747474;
        color: #333333;
        font-family: "Open Sans", sans-serif;
        }

    .select2-dropdown--custom .select2-results {
      max-height: 150px;
      overflow-y: auto;
    }

    .select2-dropdown--custom .select2-results .select2-results__options:not(.select2-results__options--nested) {
      max-height: 150px;
      overflow-y: auto;
    }

    .select2-dropdown--custom .select2-results .select2-results__option {
        padding: 5px 13px;
        font-size: 16px;
        line-height: 1.375;
        transition: color .3s linear;
        }

    .select2-dropdown--custom .select2-results .select2-results__option.select2-results__option--highlighted {
        color: #ED1651;
        }

    .select2-dropdown--custom .select2-results .select2-results__option .select2-results__group {
        font-size: 13px;
        line-height: 1.38;
        font-weight: 400;
        }

    .select2-dropdown--custom .select2-results .select2-results__option .select2-results__option {
        padding: 0 10px;
        }
    /* end select*/

    #reg-form.cta {
        padding-left: 20px;
        padding-right: 20px;
        background: repeat-x url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iMTIzIiB2aWV3Qm94PSIwIDAgNjAgMTIzIiBmaWxsPSIjZjVmNWY1IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgNTEuOTMzM0wzOCAwSDBWNTEuOTMzM1pNMCAxMjNIOEw2MCA1MS45MzMzVjBMMCA4MlYxMjNaTTYwIDgyTDMwIDEyM0g2MFY4MloiLz4KPC9zdmc+Cg==") #fff;
        }

    #reg-form.cta .cta__cnt {
        max-width: 1041px;
        margin-left: auto;
        margin-right: auto;
        }

    #reg-form .reg-form {
        max-width: 460px;
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        box-sizing: border-box;
        color: #333;
        font-family: "Open Sans", sans-serif;
        }

    #reg-form .reg-form.mb-minus {
        position: relative;
        z-index: 1;
        }

    #reg-form .reg-form .input-wrp:not(:last-child),
    #reg-form .reg-form .check-wrp:not(:last-child) {
        margin-bottom: 15px;
        }

    #reg-form .reg-form .button {
        display: block;
        width: 100%;
        margin-bottom: 21px;
        }

    #reg-form .reg-form .legend {
        width: 100%;
        line-height: 1.6;
        text-align: center;
        }

    #reg-form .reg-img {
        display: block;
        width: 100%;
        margin-left: auto;
        }

    @media (max-width: 1023px) {
        #reg-form.cta {
            padding-top: 38px;
            background-position: center 110px;
            background-size: auto 59px;
            }

        #reg-form .reg-form {
            width: 100%;
            padding: 25px 20px 40px;
            margin-left: auto;
            margin-right: auto;
            }

        #reg-form .reg-form.mb-minus {
            margin-bottom: -49px;
            }

        #reg-form .reg-form .legend {
            margin-bottom: 19px;
            font-size: 18px;
            white-space: pre;
            }

        #reg-form .reg-img {
            max-width: 195px;
            margin-right: auto;
            }
        }

    @media (min-width: 1024px) {
        #reg-form.cta {
            padding-top: 94px;
            background-position: center bottom;
            background-size: auto 123px;
            }

        #reg-form.cta .cta__cnt {
            display: flex;
            flex-flow: row-reverse nowrap;
            align-items: flex-end;
            }

        #reg-form .reg-form {
            padding: 45px 66px 60px 74px;
            }

        #reg-form .reg-form.mb-minus {
            margin-bottom: -123px;
            }

        #reg-form .reg-form .legend {
            margin-bottom: 30px;
            font-size: 24px;
            white-space: pre;
            }

        #reg-form .reg-img {
            max-width: 519px;
            }
        }

    /* modal */
    .modal-overlay {
        position: fixed;
        top:0; left:0; bottom: 0; right: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999991;
        box-sizing: border-box;
    }

    .modal-window {
        position: absolute;
        padding: 2.5em 2em 4em;
        margin-left: calc(50% - 22em);
        width: 40.6em;
        min-height: 12em;
        top: 30%;

        background: #ffffff;
        z-index: 999992;

        font-size: 16px;
    }
    .modal-window a {
        color: #3393D8 !important;
    }

    .close {
        position: absolute;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        right: 2em;
        z-index: 5;
        cursor: pointer;
    }

    .close-window {
        width: 1.3em;
        height: 1.3em;
    }

    .close-window:hover {
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
    }

    .headline {
        margin-bottom: 1.5em;
        padding-right: 2.25em;
        font-family: Open Sans,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 1.5em;
    }

    .register-another-email {
        text-decoration: none;
        color: #3393d8;
        font-family: Open Sans,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 1em;
        cursor: pointer;
    }

    @media screen and (max-width: 800px) {
        .modal-window {
            position: absolute;
            padding: 1.2em 2em;
            margin-left: calc(50% - 14.2em);

            width: 25em;
            min-height: 12.5em;
            top: 30%;

            background: #ffffff;

            font-size: 1em;
        }

        .close {
            position: absolute;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            right: 1em;
            z-index: 5;
        }

        .close-window {
            width: 1.3em;
            height: 1.3em;
        }

        .close-window:hover {
            -webkit-transform: scale(1.1);
            -ms-transform: scale(1.1);
            transform: scale(1.1);
        }

        .headline {
            margin-bottom: 16px;

            font-family: Open Sans,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 1.5em;

            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        .register-another-email {
            padding-top: 30px;
            text-decoration: none;
            color: #3393d8;

            font-family: Open Sans,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 1em;
        }
    }

    @media screen and (max-width: 480px) {
        .modal-window {
            position: absolute;
            padding: 1.2em 1.2em;

            margin-left: calc(50% - 11.2em);
            width: 20em;
            min-height: 10.7em;
            top: 30%;

            background: #ffffff;
            font-size: 14px;
        }

        .close {
            position: absolute;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            right: 1em;
            z-index: 5;
        }

        .close-window {
            width: 1.3em;
            height: 1.3em;
        }

        .close-window:hover {
            -webkit-transform: scale(1.1);
            -ms-transform: scale(1.1);
            transform: scale(1.1);
        }

        .headline {
            margin-bottom: 14px;

            font-family: Open Sans,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 1.5em;

            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        .register-another-email {
            text-decoration: none;
            color: #3393d8;
            font-family: Open Sans,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 1em;
        }
    }
    /* end modal */
</style>
